import React from "react";
import Navbar from "../components/Navbar/Navbar";
import Slider from "../components/Slider/Slider";
import Movie from "../components/Movie/Movie";
import InfiniteScroll from "react-infinite-scroll-component";
import axios from "axios";
import { v4 as uuid } from "uuid";

function Home() {
  const [movies, setMovies] = React.useState([]);
  const [hasMore, setHasMore] = React.useState(true);
  const [page, setCurrentPage] = React.useState(1);

  const getMovies = async () => {
    const response = await axios({
      method: "GET",
      url: `https://api.themoviedb.org/3/discover/movie?api_key=${process.env.REACT_APP_API_KEY}`,
      params: {
        include_adult: false,
        page: page,
      },
    });

    setMovies([...movies, ...response.data.results]);

    response.data.results.length === 0 || response.data.results.length < 20
      ? setHasMore(false)
      : setHasMore(true);

    setCurrentPage((prev) => prev + 1);
  };

  React.useEffect(() => {
    getMovies().catch(alert);
  }, []);

  const createUniqueId = () => {
    const unique_id = uuid();
    return unique_id;
  };

  return (
    <>
      <Navbar />
      <Slider />
      <div className="container mt-5">
        <h3 className="text-start">Trending</h3>
        <hr className="mt-3" />
        <InfiniteScroll
          dataLength={movies.length}
          next={() => {
            getMovies().catch(alert);
          }}
          hasMore={hasMore}
          style={{ overflow: "hidden" }}
        >
          {movies ? (
            <div className="row mt-5">
              {movies.map((movie) => (
                <Movie key={createUniqueId()} movie={movie} />
              ))}
            </div>
          ) : (
            <p>Not results found</p>
          )}
        </InfiniteScroll>
      </div>
    </>
  );
}

export default Home;
